// @flow
import TradesTable from './TradesTable';
import connect from './connect';

export default connect(TradesTable);



// WEBPACK FOOTER //
// ./src/components/TradesTable/index.js